<template>
  <div class="about flex-fill m-auto p-3">
    <div class="full flex-fill h-100">
      <div class="container-fluid">
        <div class="row header">
          <div class="col-12">
            <h1 class="text-light pt-3 pb-3">About This Site</h1>
          </div>
        </div>
        <div class="row fs-5 text-muted text-start">
          <p>The purpose of this website was to create a fast, mobile friendly way to get quick power outage information for Rhode Island. This is not 
             intended to be a replacement of the official site which has a very detailed map on every outage and restoration times for specific zones. 
             Instead, this does a roll-up to the city/town level and provides a timeline of outages throughout the day in 10 min segments. The timeline
             helps visualize the trend of the outages (increasing or decreasing) and is unique to this site.
          </p>
          <p>This website was created using Python, Javascript and Amazon Web Services (AWS). The data is collected & 
             processed every 10 mins with Python on AWS Lambda so it can continue to run even in the event of a local power outage. 
             The data is stored in an AWS S3 bucket tracking 24-hour segments and archiveing any days with more than a 5% statewide outage. 
             The frontend is created using Vue.js & Bootstrap 5. The charts are created with Chart.js and the map is made with leaflet.js.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style>
.about {
  max-width: 66.875rem;
  margin-left: auto;
  margin-right: auto;
  align-content: center;
}
</style>